import React, { useCallback } from 'react';
import { StyledNumericInput } from '@/components/mui/Form/TextField/StyledComponent';

const IntegerInput = React.forwardRef(({ value, onChange: inputOnChange, className, ...rest }, ref) => {
  const onChange = useCallback(
    (e) => {
      inputOnChange(e.value || null);
    },
    [inputOnChange],
  );

  return (
    <StyledNumericInput
      getInputRef={ref}
      thousandSeparator
      decimalScale={0}
      allowNegative={false}
      value={value ?? ''}
      onValueChange={onChange}
      type="text"
      dir="ltr"
      className={className}
      {...rest}
    />
  );
});

export default React.memo(IntegerInput);
